import React from "react";

const LeftSideContent = ({ loading, step }) => {
  if (loading && step === 1) {
    return (
      <div className="space-y-6">
        <div className="space-y-2">
          <div className="h-8 w-32 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse"></div>
        </div>
        <div className="space-y-1">
          <div className="h-4 w-48 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h2 className="text-xl lg:text-2xl font-bold text-[#6200EE] leading-tight">
          Book a Demo
        </h2>
        <p className="text-sm lg:text-base text-[#1E1E1E] opacity-70 leading-relaxed">
          Let RegTechFlow handle the boring stuff! See how we automate
          corporate, compliance and licensing processes in just a few clicks.
        </p>
      </div>

      <div className="space-y-1">
        <p className="text-sm lg:text-base text-[#1E1E1E] leading-relaxed">
          Ready to see it in action?
        </p>
        <p className="text-sm lg:text-base font-semibold text-[#1E1E1E] leading-relaxed">
          Book your demo today!
        </p>
      </div>
    </div>
  );
};

export default LeftSideContent;
